import { render, staticRenderFns } from "./HolidayModal.vue?vue&type=template&id=fd2faca4&scoped=true&"
import script from "./HolidayModal.vue?vue&type=script&lang=js&"
export * from "./HolidayModal.vue?vue&type=script&lang=js&"
import style0 from "./HolidayModal.vue?vue&type=style&index=0&id=fd2faca4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2faca4",
  null
  
)

export default component.exports